module.exports = __webpack_public_path__ + "img/person-3.f2f190f8.png";